import { useState, useEffect, useRef } from "react";
import api from "../services/api";
import { useToast } from "../context/ToastContext";
import { useForm } from "react-hook-form";
import { SCFieldset, SCButton, SCInputTextarea, } from "../components";
import { useAuth } from "../providers/auth";
import util from '../utilities/util';
import { TabPanel, TabView } from "primereact/tabview";

const ConfiguracoesFormulasFinanceiro = () => {
    const toast = useToast();
    const tarefa = "ConfiguracoesFormulasFinanceiro";
    const { periodoSelecionado } = useAuth();

    const [camposHabilitados, setCamposHabilitados] = useState<{ [key: string]: boolean }>({});
    const [editarDesabilitado, setEditarDesabilitado] = useState<boolean>();
    const [valorOriginal, setValorOriginal] = useState({});
    const [activeIndex, setActiveIndex] = useState(0);

    const camposDeFormulasMensalidade = [{ name: 'FormulaJuros', label: 'Juros' },
    { name: 'FormulaMultas', label: 'Multa' },
    { name: 'FormulaDesconto', label: 'Desconto' },
    { name: 'FormulaVariavel1', label: 'Variável de Apoio 1' },
    { name: 'FormulaVariavel2', label: 'Variável de Apoio 2' }];

    const camposDeFormulasOutRec = [{ name: 'FormulaOutRecJuros', label: 'Juros' },
    { name: 'FormulaOutRecMultas', label: 'Multa' },
    { name: 'FormulaOutRecVariavel1', label: 'Variável de Apoio 1' },
    { name: 'FormulaOutRecVariavel2', label: 'Variável de Apoio 2' }];

    const methods = useForm({});
    const { handleSubmit, control, formState: { errors }, watch, setValue, getValues, } = methods;

    const load = async () => {
        setEditarDesabilitado(false)
        const financeiroFormulas = await api.get('/financeiroFormulas', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
            }
        });

        const dados = financeiroFormulas.data?.[0] ?? {};

        camposDeFormulasMensalidade.forEach(({ name }) => {
            if (dados[name] !== undefined) {
                setValue(name, dados[name]);
            }
        });

        camposDeFormulasOutRec.forEach(({ name }) => {
            if (dados[name] !== undefined) {
                setValue(name, dados[name]);
            }
        });

    };

    useEffect(() => {
        load();
    }, []);


    const handleEdit = (field: string) => {
        const value = getValues(field);
        setValorOriginal(value)
        setCamposHabilitados((prev) => ({ ...prev, [field]: true }));
        setEditarDesabilitado(true)
    };

    const handleCancel = (field: string) => {
        setValue(field, valorOriginal ? valorOriginal : '')
        setEditarDesabilitado(false)
        setCamposHabilitados((prev) => ({ ...prev, [field]: false }));
    }

    const handleSave = async (field: string, label: string) => {
        const value = getValues(field);

        const financeiroFormulas = await api.get('/financeiroFormulas', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
            }
        })

        setCamposHabilitados((prev) => ({ ...prev, [field]: false }));

        if (financeiroFormulas.data.length > 0) {
            const updateFinanceiroFormulas = {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                [field]: value
            }

            await api.put('/financeiroFormulas', updateFinanceiroFormulas)
        } else {
            const createFinanceiroFormulas = {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                [field]: value
            }

            await api.post('/financeiroFormulas', createFinanceiroFormulas)
        }

        toast.showToast({ severity: 'success', summary: 'Sucesso', detail: `Fórmula "${label}" salvo com sucesso.` });
        setEditarDesabilitado(false)
    };

    const renderHeader = (title: string, index: number) => (
        <div
            onClick={() => {
                if (!editarDesabilitado) {
                    setActiveIndex(index);
                }
            }}
            style={{
                backgroundColor: activeIndex === index ? '#0772B3' : '#ffffff',
                color: activeIndex === index ? '#ffffff' : '#000000',
                padding: '8px 12px',
                borderRadius: '4px',
                fontWeight: activeIndex === index ? 'bold' : 'normal',
                cursor: 'pointer'
            }}
        >
            {title}
        </div>
    );

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-center align-items-center p-2 border-round-top-md text-white" style={{ backgroundColor: "#0772B3" }}>
                        <h5 className="m-0 flex flex-1 align-items-center justify-content-center">
                            Configurações de Fórmulas do Financeiro
                        </h5>
                    </div>

                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="mt-3">
                        <TabPanel headerTemplate={() => renderHeader('Mensalidades', 0)}>
                            <SCFieldset legend="Configurando Fórmulas de Mensalidades" className="mt-2" >
                                <div className="grid">
                                    {camposDeFormulasMensalidade.map(({ name, label }) => (
                                        <div className="col-12 pt-2" key={name}>
                                            <div className="flex gap-2">
                                                <div className="flex-grow-1">
                                                    <SCInputTextarea
                                                        control={control}
                                                        name={name}
                                                        label={label}
                                                        style={{ width: '100%', textTransform: 'uppercase' }}
                                                        rows={4}
                                                        disabled={!camposHabilitados[name]}
                                                    />
                                                </div>
                                                <div className="flex flex-column gap-2 pt-4" style={{ minWidth: '85px' }}>
                                                    <SCButton
                                                        icon="pi pi-pencil"
                                                        className="p-button-info"
                                                        style={{ width: '100%' }}
                                                        onClick={() => handleEdit(name)}
                                                        disabled={editarDesabilitado}
                                                        label="Editar"
                                                    />
                                                </div>
                                                <div className="flex flex-column gap-2 pt-4" style={{ minWidth: '85px' }}>
                                                    <SCButton
                                                        icon="pi pi-save"
                                                        className="p-button-success"
                                                        style={{ width: '100%' }}
                                                        onClick={() => handleSave(name, label)}
                                                        disabled={!camposHabilitados[name]}
                                                        label="Gravar"
                                                    />
                                                    <SCButton
                                                        icon="pi pi-times"
                                                        className="p-button-danger"
                                                        style={{ width: '100%' }}
                                                        onClick={() => handleCancel(name)}
                                                        disabled={!camposHabilitados[name]}
                                                        label="Cancelar"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </SCFieldset>
                        </TabPanel>
                        <TabPanel headerTemplate={() => renderHeader('Outros Recebimentos', 1)}>
                            <SCFieldset legend="Configurando Fórmulas de Outros Recebimentos" className="mt-2" >
                                <div className="grid">
                                    {camposDeFormulasOutRec.map(({ name, label }) => (
                                        <div className="col-12 pt-2" key={name}>
                                            <div className="flex gap-2">
                                                <div className="flex-grow-1">
                                                    <SCInputTextarea
                                                        control={control}
                                                        name={name}
                                                        label={label}
                                                        style={{ width: '100%', textTransform: 'uppercase' }}
                                                        rows={4}
                                                        disabled={!camposHabilitados[name]}
                                                    />
                                                </div>
                                                <div className="flex flex-column gap-2 pt-4" style={{ minWidth: '85px' }}>
                                                    <SCButton
                                                        icon="pi pi-pencil"
                                                        className="p-button-info"
                                                        style={{ width: '100%' }}
                                                        onClick={() => handleEdit(name)}
                                                        disabled={editarDesabilitado}
                                                        label="Editar"
                                                    />
                                                </div>
                                                <div className="flex flex-column gap-2 pt-4" style={{ minWidth: '85px' }}>
                                                    <SCButton
                                                        icon="pi pi-save"
                                                        className="p-button-success"
                                                        style={{ width: '100%' }}
                                                        onClick={() => handleSave(name, label)}
                                                        disabled={!camposHabilitados[name]}
                                                        label="Gravar"
                                                    />
                                                    <SCButton
                                                        icon="pi pi-times"
                                                        className="p-button-danger"
                                                        style={{ width: '100%' }}
                                                        onClick={() => handleCancel(name)}
                                                        disabled={!camposHabilitados[name]}
                                                        label="Cancelar"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </SCFieldset>
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </div>
    );
};

export default ConfiguracoesFormulasFinanceiro;
